<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      
      <v-flex md12>
        <app-table
          ref="accountTable"
          title="Accounts"
          :config="config"
          @emulateUser="emulateUser"
        >

          <!--template slot='headerActions'>
            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  color="secondary"
                  @click="open_in_new()">
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>

              </template>
              <span>Request New Account</span>
            </v-tooltip>        
          </template-->
        </app-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from './config_index.js'
import { startEmulation } from '@/utils/auth'


export default {
  data () {
    return { config }
  },
  methods: {
    mounted() {
    },
    emulateUser(user) {
      this.$store.dispatch("app/startLoading")
      startEmulation(user.id)
      location.reload()
    },
    open_in_new() {
      window.open(window.location.origin + '/#/request_account', '_blank')
    }
  }
}
</script>
